import ReactDOM from "react-dom";
import React from "react";
import Room from "../containers/room";
import EmptyRoom from "../containers/empty_room";
import toast, { Toaster } from "react-hot-toast";
  


document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById("rooms-container");
  if (container !== null) {
    const token = container.dataset.token;
    const appointment = {
      start_time: container.dataset.appointmentStartDate,
      consultation: container.dataset.appointmentConsultation,
      consultationReason: container.dataset.getConsultationReason,
      patient: {
        id: container.dataset.appointmentPatientId,
        name: container.dataset.appointmentPatientName,
        type: container.dataset.appointmentPatientType,
        avatar: container.dataset.appointmentPatientAvatar,
        bookings: container.dataset.bookings,
        plan: container.dataset.plan
      },
      professional: {
        id: container.dataset.appointmentProfessionalId,
        name: container.dataset.appointmentProfessionalName,
        type: container.dataset.appointmentProfessionalType,
        avatar: container.dataset.appointmentProfessionalAvatar,
      },
    };
    const holder = {
      id: container.dataset.holderId,
      name: container.dataset.holderName,
      type: container.dataset.holderType,
      avatar: container.dataset.holderAvatar,
      notifications: container.dataset.notifications
    };
    const conversationId = container.dataset.conversationId;
    const site = container.dataset.site;
    
    const closedRoomImg = {
      firstImg: container.dataset.firstImg,
      secondImg: container.dataset.secondImg,
      thirdImg: container.dataset.thirdImg,
      calendarImg: container.dataset.calendarImg,
      evalImg: container.dataset.evalImg,
      upgradeImg: container.dataset.upgradeImg
    }

    ReactDOM.render(
        <div>
          <Room token={token} appointment={appointment} holder={holder} conversationId={conversationId} site={site} closedRoomImg={closedRoomImg} />
          <Toaster />
        </div>,

        //<EmptyRoom token={token} appointment={appointment} holder={holder} conversationId={conversationId} site={site} />
        container.appendChild(document.createElement('div')),
    )
  }
});
